export const FETCH_RESULT_MT = 'FETCH_RESULT_MT';
export const LIST_RESULT_MT = 'mt';
export const DRAW_RESULT_MT = 'DRAW_RESULT_MT';

